import { Link } from "react-router-dom";
import GossipCard from "@/components/base/GossipCard";
import VerdictBadge from "@/components/base/VerdictBadge";
import SectionHeading from "@/components/base/SectionHeading";
import { gossipList } from "@/mocks/gossip";
import { formatHeat } from "@/utils/verdict";

export default function FeaturedChecks() {
  const featured = gossipList.find((item) => item.verdict === "实锤") ?? gossipList[0];
  const side = gossipList.filter((item) => item.id !== featured.id).slice(0, 3);

  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="max-w-shell mx-auto px-4 md:px-6 py-12 md:py-16">
        <SectionHeading
          eyebrow="本期重点"
          title="本周重点鉴定"
          description="挑出证据链最完整、争议最集中的三条，把比对过程完整摊开给你看。"
          action={{ label: "全部爆料", to: "/gossip" }}
        />

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-5">
          <div className="lg:col-span-8">
            <GossipCard item={featured} variant="featured" />
          </div>

          <div className="lg:col-span-4 border border-background-200 rounded-card bg-background-50 overflow-hidden flex flex-col">
            <div className="px-5 py-4 border-b border-background-200 bg-background-100">
              <h3 className="font-heading text-base font-bold text-foreground-950 flex items-center gap-2">
                <i className="ri-radar-line text-primary-500"></i>
                同步在看的瓜
              </h3>
              <p className="mt-1 text-xs text-foreground-500">按热度排序，鉴定进度实时更新</p>
            </div>
            <ul className="flex-1 divide-y divide-background-200">
              {side.map((item) => (
                <li key={item.id}>
                  <Link
                    to={`/gossip/${item.id}`}
                    className="block px-5 py-4 group hover:bg-background-100 transition-colors"
                  >
                    <div className="flex items-center gap-2 mb-2">
                      <VerdictBadge verdict={item.verdict} size="sm" showIcon={false} />
                      <span className="text-[11px] text-foreground-400">{item.category}</span>
                    </div>
                    <p className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                      {item.title}
                    </p>
                    <div className="mt-2 flex items-center gap-3 text-[11px] text-foreground-400">
                      <span className="flex items-center gap-1">
                        <i className="ri-fire-line"></i>
                        {formatHeat(item.heat)}
                      </span>
                      <span>可信度 {item.credibility}</span>
                      <span>{item.evidence.length} 条证据</span>
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
            <div className="px-5 py-4 border-t border-background-200">
              <Link
                to="/gossip"
                className="flex items-center justify-between text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
              >
                进入爆料库
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}